import { useState, useEffect, useRef } from "react";
import Select from "react-select";

const CustomSelectWithIcon = ({
  handleApply,
  options,
  name,
  defaultValue = "",
  placeholder = "Select an option",
  isSearchable = false,
  className = "",
  disabled = false,
  isMultiple = false,
  closeMenuOnSelect = true,
  style = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState([]);
  const containerRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const handleApplyClick = () => {
    const valueToApply = isMultiple ? selectedValue.map((item) => item.value).join(",") : selectedValue.value;
    handleApply(name, valueToApply);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target) &&
      event.target.tagName !== "path" &&
      event.target.tagName !== "svg"
    ) {
      setIsOpen(false);
    }
  };

  const convertDefaultValueToArray = () => {
    const defaultValueArray = defaultValue?.split(",") || [];
    return options?.filter((option) => defaultValueArray.includes(String(option.value))) || [];
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isOpen) {
      const selectedOptions = convertDefaultValueToArray();
      setSelectedValue(selectedOptions);
    }
  }, [isOpen]);

  useEffect(() => {
    if (defaultValue && options?.length > 0) {
      const selectedOptions = convertDefaultValueToArray();
      setSelectedValue(selectedOptions);
    }
    if (!defaultValue && !isOpen) {
      setSelectedValue([]);
    }
  }, [defaultValue, options]);

  return (
    <div className="position-relative fw-normal" ref={containerRef}>
      <i className={`bi bi-filter f-s-16 cursor-pointer ${selectedValue.length && "text-primary"}`} onClick={handleToggle} />
      {isOpen && (
        <div
          className={`position-absolute top-100 left-center d-flex flex-column align-items-center gap-1 rounded bg-white p-1 shadow ${className}`}
          style={{ zIndex: 1050, ...style }}
        >
          <div className="d-flex w-100 align-items-center justify-content-between px-1">
            <div className="d-flex gap-3">
              {isMultiple && (
                <span className="cursor-pointer text-decoration-underline text-primary small" onClick={() => setSelectedValue(options)}>
                  Select All
                </span>
              )}
              <span className="cursor-pointer text-decoration-underline text-primary small" onClick={() => setSelectedValue([])}>
                Clear
              </span>
            </div>
            <span className="cursor-pointer text-decoration-underline text-primary small" onClick={handleApplyClick}>
              Apply
            </span>
          </div>
          <Select
            name={name}
            value={selectedValue}
            onChange={handleChange}
            isDisabled={disabled}
            options={options}
            placeholder={placeholder}
            className="w-100"
            menuPortalTarget={document.body}
            isSearchable={isSearchable}
            isMulti={isMultiple}
            closeMenuOnSelect={closeMenuOnSelect}
            styles={{
              control: (provided) => ({
                ...provided,
                maxHeight: "160px",
                overflowY: "auto",
              }),
              menuList: (provided) => ({
                ...provided,
                maxHeight: "200px",
                overflowY: "auto",
              }),
              menuPortal: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CustomSelectWithIcon;
